import React, { useState } from 'react'
import { ImNotification } from "react-icons/im";
import { FaArrowUpLong, FaCopy, FaLink } from "react-icons/fa6";
import { IoMdArrowDropdownCircle } from "react-icons/io";
import { useSelector } from 'react-redux';

const MembersTotalBox = () => {
    const [isOpen, setIsOpen] = useState(false);
const MemeberData=useSelector(state=>state.user.UserActivityData)


    const data = [
        { text: "x3/x4", link: "0x5ac...B97", icon: <FaCopy />, linkIcon: <FaLink /> },
        { text: "xXx", link: "0x2CA...e52", icon: <FaCopy />, linkIcon: <FaLink /> },
        // { text: "xGold", link: "0x988...7C5", icon: <FaCopy />, linkIcon: <FaLink /> },
        // { text: "xQore", link: "0x1ee...a78", icon: <FaCopy />, linkIcon: <FaLink /> },
        // { text: "maxQore", link: "0x27D...260", icon: <FaCopy />, linkIcon: <FaLink /> },
    ]

    const onHide = () => {
        setIsOpen(!isOpen);
    }
    return (
        <>
            <div>
                <div className='my-5'>
                    <h1 className='text-white flex items-center gap-3  text-2xl font-bold '>Platform recent activity <span className='mt-2'><ImNotification size={20} /></span></h1>
                </div>
                <section className='py-4 px-4 rounded-xl  md:rounded-xl lg:rounded-xl my-5 w-full px:mx-10   bg-[#333]'>
                    <p className='flex py-2 text-sm items-center gap-3 text-gray-300'>Members total <span><ImNotification size={20} /></span></p>
                    <p className='text-xl text-white font-bold'>{MemeberData.Total_Users}</p>
                    <p className='flex items-center text-green-500 gap-1'><FaArrowUpLong size={15} /><span >{MemeberData.Total_Users}</span></p>
                </section>
                <section className='py-4 px-4 rounded-xl  md:rounded-xl lg:rounded-xl my-5 w-full px:mx-10   bg-[#333]'>
                    <p className='flex py-2 items-center text-sm  gap-3 text-gray-300'>Members received<span><ImNotification size={20} /></span></p>
                    <p className='text-xl text-white font-bold py-1'>{MemeberData.Total_Busd_Users} BUSD</p>
                    <p className='flex items-center text-green-500 gap-1'><span >{MemeberData.Total_Busd_Users} BUSD</span></p>
                    {/* <hr className='border-[1px] h-[1px] my-2 border-gray-700' /> */}
                    {/* <p className='text-xl text-white font-bold py-1'>22 541.4949 BNB</p> */}
                    {/* <p className='flex items-center text-green-500 gap-1'><span >+ 0.744 BNB</span></p> */}
                </section>
                <section className='py-4 px-4 rounded-xl  md:rounded-xl lg:rounded-xl my-5 w-full px:mx-10   bg-[#333]'>
                    <div className='flex justify-between  items-center'>
                        <p className='flex py-2 items-center text-sm  gap-3 text-gray-300'>Forsage BUSD Contracts</p>
                        <span onClick={onHide} className='text-white  cursor-pointer'><IoMdArrowDropdownCircle size={20} /></span>
                    </div>
                    {/* hide section */}
                    <div className={isOpen === true ? "md:block" :"md:block hidden "}>
                        {
                            isOpen ? (
                                <ul >
                                    {
                                        data.map((item, index) => (
                                            <li key={index}>
                                                <hr className='border-[1px] h-[1px] my-2 border-gray-700' />
                                                <ul className='flex items-center justify-between'>
                                                    <li className='text-gray-400'>{item.text}</li>
                                                    <li className='flex text-white gap-3 items-center justify-between'>
                                                        <span>{item.link}</span>
                                                        <span className=' cursor-pointer'>{item.icon}</span>
                                                        <span className='text-gray-400 cursor-pointer'>{item.linkIcon}</span>
                                                    </li>
                                                </ul>

                                            </li>
                                        ))
                                    }
                                    {/* <div className='py-2'>
                                        <p className='flex py-2 items-center text-sm  gap-3 text-gray-300'>Transactions made</p>
                                        <p className='text-xl text-white font-bold py-1'>5 910 629</p>
                                        <p className='flex items-center text-green-500 gap-1'><span >+ 1 009</span></p>
                                        <hr className='border-[1px] h-[1px] my-2 border-gray-700' />
                                        <p className='flex py-2 items-center text-sm  gap-3 text-gray-300'>Turnover, BUSD</p>
                                        <p className='text-xl text-white font-bold py-1'>296 726 094.64</p>
                                        <p className='flex items-center text-green-500 gap-1'><span >+ 25 552</span></p>
                                    </div> */}
                                </ul>
                            ) : ""
                        }
                    </div>
                </section>
            </div>
        </>
    )
}

export default MembersTotalBox